import store_article from "@/store/mods/stock/articles"

export default {
    name: 'recap-monthly-consumption',
    components: {},
    props: [],
    data() {
        return {
            l_months: [
                { id: 1, libelle: "Jan.", value: 0 }, { id: 2, libelle: "Fév.", value: 0 },
                { id: 3, libelle: "Mars", value: 0 }, { id: 4, libelle: "Avril", value: 0 },
                { id: 5, libelle: "Mai", value: 0 }, { id: 6, libelle: "Juin", value: 0 },
                { id: 7, libelle: "Juil.", value: 0 }, { id: 8, libelle: "Août", value: 0 },
                { id: 9, libelle: "Sept.", value: 0 }, { id: 10, libelle: "Oct.", value: 0 },
                { id: 11, libelle: "Nov.", value: 0 }, { id: 12, libelle: "Déc.", value: 0 },
            ],
            l_years: [],
            curr_year: '',
            recap_loading: true,
            monthly_consumptions: [],
            global_total: 0
        }
    },

    watch: {
        curr_year() {
            this.getMonthlyConsumption();
        }
    },

    computed: {

    },

    mounted() {
        this.curr_year = new Date().getFullYear()
        console.log("Y: ", this.curr_year);
        
        this.getYears()
    },

    methods: {
        getYears() {
            // Set years from 2019 to the current year
            const currentYear = new Date().getFullYear();
            this.l_years = [];
            for (let year = 2019; year <= currentYear; year++) {
                this.l_years.push(year.toString());
            }
        },

        getMonthlyConsumption() {
            this.recap_loading = true
            this.l_months = [
                { id: 1, libelle: "Jan.", value: 0 }, { id: 2, libelle: "Fév.", value: 0 },
                { id: 3, libelle: "Mars", value: 0 }, { id: 4, libelle: "Avril", value: 0 },
                { id: 5, libelle: "Mai", value: 0 }, { id: 6, libelle: "Juin", value: 0 },
                { id: 7, libelle: "Juil.", value: 0 }, { id: 8, libelle: "Août", value: 0 },
                { id: 9, libelle: "Sept.", value: 0 }, { id: 10, libelle: "Oct.", value: 0 },
                { id: 11, libelle: "Nov.", value: 0 }, { id: 12, libelle: "Déc.", value: 0 },
            ]
            this.global_total = 0
            // Logic to fetch monthly consumption data   
            const data = {
                article_id: this.$route.params.id,
                curr_year: this.curr_year
            }
            console.log(data);
            store_article.getMonthlyConsumption(data).then((response) => {
                this.monthly_consumptions = response

                this.l_months.forEach((el, index) => {
                    this.monthly_consumptions.forEach(mc => {
                        if (el.id == mc.month) {
                            this.l_months[index].value = parseInt(mc.total_nombre)
                            this.global_total += parseInt(mc.total_nombre)
                        }
                    });
                });

                this.recap_loading = false
            })
        }
    }
}